import { LockFilledSVG, Icon } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  powerWordWrapperCss,
  powerWordCss,
  definitionBodyCss,
} from "../PowerWordPopoutBody.style";
import { TITLE, DESCRIPTION } from "./constants";
import { liteLockGroupCss } from "./PowerWordLiteLockVeil.style";

const propTypes = {
  currentFontSize: PropTypes.string.required,
};

export const PowerWordLiteLockVeil = ({ currentFontSize }) => (
  <>
    <div css={powerWordWrapperCss}>
      <div css={liteLockGroupCss}>
        <h3 css={powerWordCss(currentFontSize)}>{TITLE}</h3>
        <Icon
          SvgComponent={LockFilledSVG}
          size={Icon.sizes.sm}
          isDecorative={false}
          title="locked"
        />
      </div>
    </div>
    <div css={definitionBodyCss(currentFontSize)}>{DESCRIPTION}</div>
  </>
);

PowerWordLiteLockVeil.propTypes = propTypes;

export default PowerWordLiteLockVeil;
